import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const UpdateAccountTypeIA: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_ACCOUNT_TYPE(strictLocalize),
    getDescription: () => [
      PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize),
      FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize),
      SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize),
      ONCE_WE_RECEIVE_THIS_INFO(strictLocalize),
    ],
  };
};

const UPDATE_ACCOUNT_TYPE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Update account type to “Brick and Mortar”",
    description: {
      text: "Title for the answer of Update account type to “Brick and Mortar” issue",
    },
  });

const PLEASE_SEND_US_THE_FOLLOWING_INFO = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "To get this started, please send us the following information using the contact option(s) provided in the “Contact Us” section:",
  });

const FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "1. The physical address of your brick and mortar shop",
  });

const SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "2. Interior and exterior photos of your shop with your shop sign visible in the exterior photos",
  });

const ONCE_WE_RECEIVE_THIS_INFO = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Once we receive this information, our support team will be happy to update your account type or discuss any questions that we might have for you.",
  });
